import React from "react";
import "./App.css";
import "./responsive.css";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import HomeScreen from "./screens/HomeScreen";
import ProductScreen from "./screens/productScreen";
import CategoriesScreen from "./screens/CategoriesScreen";
import OrderScreen from "./screens/OrderScreen";
import OrderDetailScreen from "./screens/OrderDetailScreen";
import AddProduct from "./screens/AddProduct";
import Login from "./screens/LoginScreen";
import UsersScreen from "./screens/UsersScreen";
import ProductEditScreen from "./screens/ProductEditScreen";
import BlogEditScreen from "./screens/BlogEditScreen";
import NotFound from "./screens/NotFound";
import { ChakraProvider } from '@chakra-ui/react'
import PrivateRouter from "./PrivateRouter";
import BlogScreen from "./screens/BlogScreen";
import AddBlog from "./screens/AddBlog";
import FaqScreen from "./screens/FaqScreen";
import FaqEditScreen from "./screens/FaqEditScreen";
import AddFaq from "./screens/AddFaq";
import AddSlider from "./screens/AddSlider";
import SliderEditScreen from "./screens/SliderEditScreen";
import SliderScreen from "./screens/SliderScreen";

function App() {

  return (
    <ChakraProvider>
      <Router>
        <Switch>
          <PrivateRouter path="/" component={HomeScreen} exact />
          <PrivateRouter path="/users" component={UsersScreen} />
          <PrivateRouter path="/products" component={ProductScreen} />
          <PrivateRouter path="/addproduct" component={AddProduct} />
          <PrivateRouter path="/product/:id/edit" component={ProductEditScreen}/>
          <PrivateRouter path="/blogs" component={BlogScreen} />
          <PrivateRouter path="/addblog" component={AddBlog} />
          <PrivateRouter path="/blog/:id/edit" component={BlogEditScreen}/>
          <PrivateRouter path="/category/edit/:id" component={CategoriesScreen} />
          <PrivateRouter path="/category" component={CategoriesScreen} />
          <PrivateRouter path="/orders" component={OrderScreen} />
          <PrivateRouter path="/order/:id" component={OrderDetailScreen} />
          <PrivateRouter path="/faqs" component={FaqScreen}/>
          <PrivateRouter path="/addfaq" component={AddFaq} />
          <PrivateRouter path="/faq/:id/edit" component={FaqEditScreen}/>
          <PrivateRouter path="/sliders" component={SliderScreen}/>
          <PrivateRouter path="/addslider" component={AddSlider}/>
          <PrivateRouter path="/slider/:id/edit" component={SliderEditScreen}/>
          <Route path="/login" component={Login} />
          <PrivateRouter path="*" component={NotFound} />
        </Switch>
      </Router>
     </ChakraProvider>

  );
}

export default App;
